<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'board_v3_tab_timeline_history' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-50 text-orange-600">
      <app-icon>history</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-base font-bold leading-6 text-gray-900">{{ 'board_v3_tab_timeline_history' | translate }}</h2>
      @if (chatTitle) {
        <p class="m-0 truncate text-sm leading-5 text-gray-500">{{ chatTitle }}</p>
      }
    </div>
    <app-button btnType="icon" [ariaLabel]="'close' | translate" (onChangeClick)="close.emit()">
      <app-icon>close</app-icon>
    </app-button>
  </header>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto bg-gray-50 px-4 py-4">
    <app-timeline [entityType]="TIMELINE_ENTITY_TYPE.CHAT" [entityId]="chatId" [showHeader]="false" [canPrefillReminders]="false" />
  </div>
</section>
